import { useEffect } from "react";

const SITE_URL = "https://djcglobal.net";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path = "/", image }) {
  useEffect(() => {
    const full = title
      ? title.includes("DJC Global")
        ? title
        : `${title} | DJC Global`
      : "DJC Global — A World of Opportunity for Your Business";
    document.title = full;
    if (description) setMeta("name", "description", description);
    const url = `${SITE_URL}${path === "/" ? "/" : path}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
    setMeta("property", "og:title", full);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    if (image) setMeta("property", "og:image", `${SITE_URL}${image}`);
    setMeta("name", "twitter:title", full);
    if (description) setMeta("name", "twitter:description", description);
  }, [title, description, path, image]);
  return null;
}
